module.exports = __webpack_public_path__ + "img/menorRedIcon.0f47e2b0.svg";